import FanTypeId from "src/consts/FanTypeId";
import GrainType from "src/consts/GrainType";
import LowGrainShutOffMode from "src/consts/LowGrainShutOffMode";
import MachineType from "src/consts/MachineType";

export function getEnumKeys<T extends object>(enumObj: T): string[] {
    return Object.keys(enumObj).filter(key => isNaN(Number(key)));
}

export function getEnumKey<T extends object>(enumObj: T, which: T[keyof T]): string {
    const key = Object.keys(enumObj).find(
        (key) => enumObj[key as keyof T] === which
    );
    return key || "N/A"; 
}

export function getEnumDictionary<T extends object>(enumObj: T) 
{
    const ret = Object.keys(enumObj)
        .filter((key) => isNaN(Number(key))) 
        .map((key) => ({
        label: key, 
        value: enumObj[key as keyof typeof enumObj], 
        }));

    return ret;
} 

export function getPremierPlusLgsoModeString(lgso: LowGrainShutOffMode | null | undefined){
    switch(lgso){
        case LowGrainShutOffMode.Auto:
            return 'Auto'
        case LowGrainShutOffMode.Bypass:
            return 'Bypass'
        case LowGrainShutOffMode.TimedBypass:
            return 'TimedBypass'
        default:
            return 'Unknown'
    }
}

export function getPremerPlusMachineTypeString(machineType: MachineType | null | undefined): string | null | undefined {
    switch(machineType){
        case MachineType.CenterVertical:
            return 'Center Vertical';
        case MachineType.DriFlo:
            return 'Dri-Flo';
        default:
            return machineType;
    }
}

export function getPremierPlusFanTypeString(fanType: FanTypeId | null | undefined){
    switch(fanType){
        case FanTypeId.HP10CFan27In:
            return 'HP 10C Fan 27In';
        case FanTypeId.HP20CFan30In:
            return 'HP 20C Fan 30In';
        case FanTypeId.HP15CFan27In:
            return 'HP 15C Fan 27In';
        case FanTypeId.AirMax30HP30In:
            return 'Air Max 30HP 30In';
        case FanTypeId.AirMax40HP33In:
            return 'Air Max 40HP 33In';
        case FanTypeId.AirMax50HP33In:
            return 'Air Max 50HP 33In';
        case FanTypeId.BlueFlameAxial:
            return 'Blue Flame Axial';
        case FanTypeId.BlueFlameWithTurbo:
            return 'Blue Flame With Turbo'
        default:
            return 'Unknown'
    }
}

export function getGrainTypeStr(grainType: string | null | undefined) {
    if (!grainType) return "";

    switch (grainType) {
        case GrainType.Corn:
            return "Corn";
        case GrainType.Soybeans:
            return "Soybeans";
        case GrainType.Wheat:
            return "Wheat";
        case GrainType.WheatDurum:
            return "Wheat durum";
        case GrainType.HardSpringWheat:
            return "Hard spring wheat";
        case GrainType.HardWinterWheat:
            return "Hard winter wheat";
        case GrainType.SoftWinterWheat:
            return "Soft winter wheat";
        case GrainType.Rye:
            return "Rye";
        case GrainType.LongGrainRoughRice:
            return "Long grain rough rice";
        case GrainType.MediumGrainRoughRice:
            return "Medium grain rough rice";
        case GrainType.ShortGrainRoughRice:
            return "Short grain rough rice";
        case GrainType.Sorghum:
            return "Sorghum";
        case GrainType.Barley:
            return "Barley";
        case GrainType.Oats:
            return "Oats";
        case GrainType.Sunflower:
            return "Sunflower";
        case GrainType.Canola:
            return "Canola";
        default:
            return "";
    }
}